import styled from 'styled-components';

export const Container = styled.div`
  width: 500px;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;
